<template>
  <div class="fixed flex w-full h-full top-0 z-9999 bg-white text-center">
    <div class="flex flex-col self-center items-center justify-center w-full h-full">
      <img class="w-28" src="@/assets/img/loding.gif" />
      <p class="text-primary font-notoSans mt-6">Loading...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading'
};
</script>

<style lang="scss" scoped>
.text-primary {
  color: #f08f00 !important;
}
.z-9999 {
  z-index: 99999999999999999999;
}

.fixed {
  position: fixed;
}

.flex {
  display: flex;
}

.w-full {
  width: 100%;
}

.h-full {
  height: 100%;
}

.top {
  top: 0;
}

.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

.text-center {
  text-align: center;
}

.flex-col {
  flex-direction: column;
}

.self-center {
  align-self: center;
}

.items-center {
  align-items: center;
}

.items-center {
  align-items: center;
}
</style>
